module.exports = __webpack_public_path__ + "static/media/4.247951f8.JPG";